export default "__VITE_ASSET__42adaf2c__"